import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

// Super Admin login audit log: successful and failed sign-in attempts.
export const AuditSection = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/login-audit").then((r) => setRows(r.data)).catch(() => setRows(null));
  }, []);
  if (!rows) return null;
  return (
    <Card className="shadow-none overflow-hidden mt-5" data-testid="audit-section">
      <div className="px-5 pt-4 pb-2">
        <h3 className="font-display font-bold">Login Audit Log</h3>
        <p className="text-xs text-muted-foreground">Last {rows.length} sign-in attempts (successful and failed).</p>
      </div>
      <div className="overflow-x-auto max-h-96 overflow-y-auto">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead>
            <tr className="text-left border-b border-border">
              <th className="px-5 py-2.5 overline font-medium">User</th>
              <th className="px-5 py-2.5 overline font-medium">Result</th>
              <th className="px-5 py-2.5 overline font-medium">IP</th>
              <th className="px-5 py-2.5 overline font-medium whitespace-nowrap">When</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-border/60" data-testid={`audit-row-${r.id}`}>
                <td className="px-5 py-2 font-mono text-xs">{r.email}</td>
                <td className="px-5 py-2">
                  {r.success ? <Badge className="bg-priority-low text-white hover:bg-priority-low">Success</Badge>
                    : <Badge variant="outline" className="text-destructive border-destructive/40">
                        Failed{r.reason === "pending_approval" ? " · pending approval" : ""}
                      </Badge>}
                </td>
                <td className="px-5 py-2 font-mono text-xs text-muted-foreground">{r.ip || "-"}</td>
                <td className="px-5 py-2 font-mono text-xs text-muted-foreground whitespace-nowrap">
                  {r.at ? new Date(r.at).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
